<lib-signature-pad
  [formControl]="this.formControl"
  [formlyAttributes]="this.field"
  [ngClass]="{
    'ng-dirty ng-invalid p-invalid': this.showError
  }">
</lib-signature-pad>
